/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Progress/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Action from './Action/index'
import ProgressBarIndicator from './ProgressBarIndicator/index'
import React from 'react'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Progress({
  children,
  viewPath = "/App/Widget/Content/Questions/Review/Progress"
  
}) {
  let isMedia = useIsMedia()
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Progress.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-Z16CAVF': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<ProgressBarIndicator
  viewPath={`${viewPath}/ProgressBarIndicator`}
/>
<div
  data-testid="Progress.Vertical"
  data-view-path={viewPath}
 style={{'--w-2-Z16CAVF': isMedia.mobile ? "25%" : "15%"}}
 className={`views-block ${styles.Vertical}`}
>
<Action
  viewPath={`${viewPath}/Action`}
/>
</div>
</div>
{children}
</React.Fragment>)
}